import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-scn-sanction-grid',
  templateUrl: './scn-sanction-grid.component.html',
  styleUrls: ['./scn-sanction-grid.component.css']
})
export class ScnSanctionGridComponent implements OnInit {
  title="Show Cause Noties Sanction";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/hrms/depart-enquiry/scn-sanction/scn-sanction-grid/scn-sanction-grid.component.ts